<template>
    <div>
        <BundleSwatches
            :components="bundle.components"
            class="d-flex flex-wrap gap-1"
        ></BundleSwatches>
    </div>
</template>

<script lang="ts" setup>
    import type { Bundle } from '~/types';
    import BundleSwatches from '~/components/BundleSwatches/BundleSwatches.vue';

    defineProps<{
        bundle: Bundle;
    }>();
</script>

<style lang="scss"></style>
